module.exports = __webpack_public_path__ + "static/media/599.7554.7ed9d11c.pdf";